import {
  anAggregationRule,
  mockRuleItemQueryOperationQuery,
} from '__generated__';
import { SAMPLE_RULES } from 'mocks/shared/rules';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRuleItemQueryOperationQuery(async ({ query: _query, variables }) => {
    await delay(1500);
    const { id } = variables;

    const rule = SAMPLE_RULES.find((rule) => rule.id === id);

    return HttpResponse.json({
      data: {
        __typename: 'Query',
        rule: rule ?? anAggregationRule(),
      },
    });
  }),
];
